'use strict';

angular.module('ntmApp').factory('NonDailyActivities', ['$timeout', 'DailyPlanService', '$templateRequest', 'ConfirmationService', 'FlashService', 'Constants',
function ($timeout, DailyPlanService, $templateRequest, ConfirmationService, FlashService, Constants) {

    function NonDailyActivities(context) {

        var self = this;
      
        self.filters = { 'Unplanned': false, 'Weekly': false, 'Yearly': false, 'Monthly': true };
        self.searchText = '';
        self.activities = [];
        self.originalActivities = [];
        self.absentStaff = [];
        self.EditMode = false;

        function loadViaTemplateRequest() {
            $templateRequest('ng1/src/dailyPlan/views/common/custom-datepicker.html');
            $templateRequest('ng1/src/dailyPlan/views/common/custom-day.html');
        }
        loadViaTemplateRequest();

        self.selectFilter = function (type) {
            self.filters = {
                'Unplanned': false,
                'Weekly': false,
                'Yearly': false,
                'Monthly': false
            };

            self.filters[type] = true;

            self.performFiltering();
        };

        self.getCount = function (type) {
            if (self.originalActivities.length === 0) {
                return '';
            }

            return self.originalActivities.filter(function (item) {
                return item.pattenType === type && containsSearchText(item) && (context.is2ndLevel() && type === 'Weekly' ? is2ndLevelWeeklyActivityBasedOnType(item) : true);
            }).length;
        };

        self.showWeeklyFilter = function () {
            if (context.is1StLevel()) {
                return false;
            }
            if (context.is2ndLevel()) {
                switch (context.selectedActivityType) {
                    case 'Room Activities':
                        return 'Weekly (Staff)';
                    case 'Other Activities':
                        return 'Weekly (Other)';
                    case 'QC Check Activities':
                        return 'Weekly (QC Check)';
                    default:
                        return false;
                }
            }
            if (context.is3rdLevel()) {
                return 'Weekly';
            }
            return false;
        };

        self.performFiltering = function () {

            if (!self.showWeeklyFilter() && self.filters.Weekly) {
                self.filters.Weekly = false;
                self.filters.Monthly = true;
            }

            var expanded = saveExpanded();
            var activities = self.originalActivities.filter(function (item) {
                return self.filters[item.pattenType];
            });

            if (self.filters.Weekly && context.is2ndLevel()) {
                activities = activities.filter(function (item) {
                    return is2ndLevelWeeklyActivityBasedOnType(item);
                });
            }

            activities = activities.filter(function (item) {
                return containsSearchText(item) || item.type === 'Shared' && item.activities && item.activities.find(function (shared) {
                        return containsSearchText(shared);
                    });
            });

            self.activities = processActivities(activities);
            expandSaved(expanded);
        };

        function containsSearchText(activity) {
            return ((activity.name.toLowerCase().indexOf(self.searchText.toLowerCase()) !== -1) ||
                    (activity.date.toLowerCase().indexOf(self.searchText.toLowerCase()) !== -1) ||
                    (activity.areaName && activity.areaName.toLowerCase().indexOf(self.searchText.toLowerCase()) !== -1) ||
                    (activity.facilityName && activity.facilityName.toLowerCase().indexOf(self.searchText.toLowerCase()) !== -1) ||
                    (activity.roomNumber && activity.roomNumber.toLowerCase().indexOf(self.searchText.toLowerCase()) !== -1) ||
                    (activity.assignment && activity.assignment.toLowerCase().indexOf(self.searchText.toLowerCase()) !== -1) ||
                    (activity.rackId && activity.rackId.toLowerCase().indexOf(self.searchText.toLowerCase()) !== -1));
        }

        function saveExpanded() {
           return self.activities.map(function (item) { return { date: item.date, expanded: item.expanded }; });
        }

        function expandSaved(expanded) {
            if (expanded.length > 0) {
                self.activities.forEach(function (item) {
                    var date = expanded.find(function (saved) {
                        return saved.date === item.date;
                    });
                    if (date) {
                        item.expanded = date.expanded;
                    }
                });
            }
        }

        self.editItem = function (item) {
            item.editing = true;
            item.newDate = moment(item.date, 'MM-DD-YYYY').toDate();
            self.EditMode = true;
        };

        self.enableEdit = function () {
            self.EditMode = true;
            self.originalActivities.forEach(function (item) {
                item.editing = true;
                item.newDate = moment(item.date, 'MM-DD-YYYY').toDate();
            });
            self.expandAll();
        };

        self.expandAll = function () {
            self.activities.forEach(item => {
                item.expanded = true;
            });
        };

        self.collapseAll = function () {
            self.activities.forEach(item => {
                item.expanded = false;
            });
        };

        self.cancelEdit = function () {
            self.EditMode = false;
            self.originalActivities.forEach(function (item) {
                item.editing = false;
                item.newDate = undefined;
                item.warning = '';
                if (item.type === 'Shared') {
                    item.activities.forEach(function (childitem) {
                        childitem.warning = '';
                    });
                }
            });
        };

        self.editedCount = function () {
            var entities = [];
            self.activities.forEach(function (item) {
                item.items.forEach(function (childitem) {
                    if (childitem.newDate && !moment(childitem.newDate).isSame(moment(childitem.date, 'MM-DD-YYYY'), 'day')) {
                        entities.push(childitem);
                    }
                });
            });
            return entities.length;
        };

        self.reschedule = function () {
            self.loading = true;
            var entities = [];

            self.activities.forEach( function (item)  {
                item.items.forEach( function (childitem) {
                    if (childitem.newDate && !moment(childitem.newDate).isSame(moment(childitem.date, 'MM-DD-YYYY'), 'day')) {
                        entities.push(childitem);
                    }
                });
            });

            var absentStaffActivities = [];
            entities.forEach(function (activity) {
                if (activity.type === 'Activity' && activity.activityTypeId === 4) {
                    var attendance = self.absentStaff.find(function (item) {
                        return moment(item.date).isSame(moment(activity.newDate), 'days') && item.personId === activity.assignmentId;
                    });
                    if (attendance) {
                        absentStaffActivities.push({ assignment: activity.assignment, name: activity.name });
                    }
                }
            });

            if (absentStaffActivities.length === 1) {
                FlashService.Error('The activity cannot be rescheduled to the selected date because the staff will be ' + (absentStaffActivities[0].attendentString === 'pto' ? 'on PTO' : 'off'), true);
                self.loading = false;
                return;
            }

            if (absentStaffActivities.length > 1) {
                var error = 'The following staff activities cannot be rescheduled for their selected date because the staff is not present on the selected date: <br> <br>';
                absentStaffActivities.forEach(function (activity) {
                    error = error + '•	' + activity.name + ' (' + activity.assignment + ') <br>';
                });
                FlashService.Error(error, true);
                self.loading = false;
                return;
            }

            entities.forEach(function (item) {
                if (item.type === 'Activity') {
                    item.date = item.newDate;
                    item.newDate = undefined;
                }
                if (item.type === 'Shared') {
                    item.date = item.newDate;
                    item.activities.forEach(function (shared) {
                        shared.date = item.date;
                        entities.push(shared);
                    });
                    entities.splice(entities.indexOf(item), 1);
                }
            });

            DailyPlanService.RescheduleNonDailyActivities(entities).then(function () {
                self.reload();
            });
        };
        
        self.reload = function () {
            var expanded = saveExpanded();
            self.load(expanded);
            self.EditMode = false;
        };

        self.load = function (expanded) {
            self.loading = true;
            DailyPlanService.GetNonDailyActivities(getRequest()).then(function (result) {
                self.absentStaff = result.data.absentStaff;
                self.originalActivities = result.data.nonDailyActivities;
                self.originalActivities.forEach(function (data) {
                    data.date = moment(data.date).format('MM-DD-YYYY');
                });
                self.loading = false;
                self.EditMode = false;
                self.performFiltering();
                if (expanded) {
                    expandSaved(expanded);
                }
            });
        };

        self.getTileClass = function (args) {
            if (args.mode === 'day') {
                var beforeLeeway = self.editedActivity.beforeLeeway;
                var afterLeeway = self.editedActivity.afterLeeway;
                var Max = moment(context.TopBar.maximumActivityScheduleDate || context.TopBar.todayDate);
                var Min = moment(context.TopBar.todayDate);
                var date = moment(args.date);
                var scheduled = moment(self.editedActivity.date, 'MM-DD-YYYY');
                var planned = moment(self.editedActivity.datePlanned);
                if (!date.isSame(scheduled,'day') && !date.isSame(moment(self.editedActivity.newDate), 'day')) {
                    if (date.isBetween(Min, Max, 'day') || date.isSame(Max, 'day') || date.isSame(Min, 'day')) {
                        if (self.editedActivity.pattenType !== 'Unplanned') {
                            if (planned.diff(date, 'days') <= beforeLeeway && date.isSameOrBefore(planned, 'day')) {
                                return 'green-tile';
                            } else if (date.diff(planned, 'days') <= afterLeeway && date.isSameOrAfter(planned, 'day')) {
                                return 'green-tile';
                            } else {
                                return 'red-tile';
                            }
                        }
                        else {
                            return 'red-tile';
                        }
                    }
                } 
            }
        };

        self.prepareActivityDescription = function (activity) {
            var description =
                (activity.areaName && !context.is2ndLevel() && !context.is3rdLevel() ? activity.areaName + ' ● ' :
                (activity.facilityName && !context.is2ndLevel() && !context.is3rdLevel() ? activity.facilityName + ' ● ' : '')) +
                (activity.roomNumber && !context.is3rdLevel() ? activity.roomNumber + ' ● ' : '') +
                (activity.rackId ? activity.rackId + ' ● ' : '');

            return description.substring(0, description.length - 3);
                  
        };

        self.checkAttendance = function (activity) {
            if (activity.type === 'Activity') {
                activity.warning = '';

                var attendance = self.absentStaff.find(function (item) {
                    return moment(item.date).isSame(moment(activity.newDate), 'days') && item.personId === activity.assignmentId;
                });

                if (attendance) {
                    var question = 'The activity will be un-assigned because ' + activity.assignment + ' will be ' +
                        (attendance.attendentString === 'pto' ? 'on PTO' : 'off') + '.<br>Do you want to reschedule anyways?';

                    ConfirmationService.YesNoConfirmation(question, null, { no: 'Cancel', yes: 'Reschedule anyway' })
                    .No(function () {
                        activity.newDate = new Date(activity.date);
                    })
                    .Yes(function () {
                        activity.warning = 'The activity will be un-assigned because ' + activity.assignment + ' will be ' + (attendance.attendentString === 'pto' ? 'on PTO' : 'off');
                    })
                    .Ask();
                }
            }

            if (activity.type === 'Shared') {

                activity.warning = '';
                activity.activities.forEach(function (item) {
                    item.warning = '';
                });
                var listOfAbsent = [];

                activity.activities.forEach(function (sharedActivity) {
                    var attendance = self.absentStaff.find(function (item) {
                        return moment(item.date).isSame(moment(activity.newDate), 'days') && item.personId === sharedActivity.assignmentId;
                    });

                    if (attendance) {
                        sharedActivity.warning = 'The activity will be un-assigned because ' + sharedActivity.assignment + ' will be ' + (attendance.attendentString === 'pto' ? 'on PTO' : 'off');

                        var contains = listOfAbsent.filter(function (absent) {
                            return absent.person === sharedActivity.assignment && attendance.attendentString === absent.attendance;
                        });

                        if (contains.length === 0) {
                            listOfAbsent.push({ person: sharedActivity.assignment, attendance: attendance.attendentString });
                        }
                    }
                });

                if (listOfAbsent.length > 0) {
                    var confirmationText = 'The activity will be un-assigned for the following staff because: <br>';

                    listOfAbsent.forEach(function (item) {
                        confirmationText = confirmationText + '•	' + item.person + ' will be ' + (item.attendentString === 'pto' ? 'on PTO' : 'off') + '<br>';
                    });

                    confirmationText = confirmationText + ' Do you want to reschedule anyways?';


                    ConfirmationService.YesNoConfirmation(confirmationText, null, { no: 'Cancel', yes: 'Reschedule anyway' })
                    .No(function () {
                        activity.newDate = new Date(activity.date);
                        activity.activities.forEach(function (item) {
                            item.warning = '';
                        });
                    })
                    .Yes(function () {
                        activity.warning = 'One or more of the assigned staff is on PTO or OFF ' +
                                           'for the selected date and they will be un-assigned ' +
                                           '            Click Show Details to see which        ';
                    })
                    .Ask();
                }
            }
        };

        self.setEditedActivity = function (activity) {
            self.editedActivity = activity;
        };

        function is2ndLevelWeeklyActivityBasedOnType (item) {
            switch (context.selectedActivityType) {
                case 'Room Activities':
                    return item.activityTypeId === Constants.ActivityTypes.Staff || isRoomEquipmentActivity(item);
                case 'Other Activities':
                    return item.activityTypeId === Constants.ActivityTypes.FacilityArea || isOtherEquipmentActivity(item);
                case 'QC Check Activities':
                    return item.activityTypeId === Constants.ActivityTypes.QCCheck;
                default:
                    return false;
            }
        };

        function isRoomEquipmentActivity(activity) {
            return activity.activityTypeId === Constants.ActivityTypes.Equipment && activity.roomNumber === context.getRoomInfo().roomNumber;
        }

        function isOtherEquipmentActivity(activity) {            
            return activity.activityTypeId === Constants.ActivityTypes.Equipment && !activity.roomNumber;
        }

        function getRequest() {

            var request = context.getViewModeAndSelectedDate();

            if (context.is2ndLevel()) {  
                request = context.getViewModeSelectedDateAndLocation();
            }

            if (context.is3rdLevel()) {
                request = context.getViewModeSelectedDateAndLocation();
                request.roomNumber = context.getRoomInfo().roomNumber;
            }     

            request.todayDate = context.TopBar.todayDate;
            request.endDate = context.TopBar.maximumActivityScheduleDate || context.TopBar.todayDate;

            return request;
        }

        function processActivities(data) {

            var dates = [];
            
            data.forEach(function (item) {
                dates.push(item.date);
            });
            
            dates = Array.from(new Set(dates));

            dates.sort(function (a, b) {
                return moment(a, 'MM-DD-YYYY').format('YYYYMMDD') - moment(b, 'MM-DD-YYYY').format('YYYYMMDD');
            });

            var result = [];

            dates.forEach(function (date) {
                var node = {
                    isToday: moment(date, 'MM-DD-YYYY').isSame(moment(), 'days'),
                    date: moment(date, 'MM-DD-YYYY').format('dddd, MMM D, YYYY'),
                    items: data.filter(function (item) {
                        return item.date === date;
                    })
                };

                result.push(node);
            });

            return result;
        }

     }

    return (NonDailyActivities);

}]);